import config from '../../config';
import { SET_REDIRECTION } from '../constants';
import { checkStatus } from '../utils/helpers';
import { SET_GC, UPDATE_GC_AMOUNT, UPDATE_GC_BARBER } from './constants';
import { processPaymentSuccess, setProcessing, wrapWithSetProcessingAction } from '../reservation/actions';

export const setGiftCard = giftCard => dispatch => (
  dispatch({
    type: SET_GC,
    payload: giftCard,
  })
);

const showErrorMessage = dispatch => (error) => {
  dispatch(setProcessing(false));
  window.swal(
    {
      title: 'Error!',
      text: error.message,
      type: 'error',
      confirmButtonColor: '#DD6B55',
    },
  );
};

const buyGiftCardAPI = (shop, data, successUrl) => dispatch =>
  fetch(`${config.url}/shop/${shop.id}/customer-gift-card`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(checkStatus)
    .then((response) => {
      setGiftCard(response)(dispatch);
      dispatch({
        type: SET_REDIRECTION,
        payload: successUrl,
      });
      return dispatch(processPaymentSuccess());
    })
    .catch(showErrorMessage(dispatch));

export const buyGiftCard = wrapWithSetProcessingAction(buyGiftCardAPI);

export const updateGcAmount = amount => dispatch => (
  dispatch({
    type: UPDATE_GC_AMOUNT,
    payload: amount,
  })
);

export const updateSelectedBarber = barber => dispatch => (
  dispatch({
    type: UPDATE_GC_BARBER,
    payload: barber,
  })
);



// WEBPACK FOOTER //
// ./src/app/giftCard/actions.js